import React from 'react';

const ThreeScene = ({ id }) => { // Destructure id from props
  return <div id={id} style={{ width: '100%', height: '100%' }} />;
};

export default ThreeScene;
